module.exports = __webpack_public_path__ + "img/Logo-RealPlaza.f8d666d3.svg";